var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tabValue === 'spline')?_c('SplineGraphic',{attrs:{"metric-param":_vm.metricParam}}):(_vm.tabValue === 'donut')?_c('DonutGraphic',{attrs:{"metric-param":_vm.metricParam}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }